import { useCallback, useEffect, useState } from "react";
import { CommonPage, Content, LoadableContent, PageTitle } from "common/Grid";
import { PrimaryButton, SecondaryButton } from "common/Forms";
import { toast } from "react-toastify";
import { TableView } from "./TableView";
import {
  useGetRolePermissionsMutation,
  useUpdateRolePermissionsMutation,
} from "store/action/userRoleApi";

export const Page = () => {
  const [getRolePermissionsApi, { isLoading, isError }] = useGetRolePermissionsMutation();
  const [updateRolePermissionsApi, { isLoading: isUpdating }] = useUpdateRolePermissionsMutation();
  const [rows, setRows] = useState([]);
  const [originalRows, setOriginalRows] = useState([]);

  const fetchData = useCallback(async () => {
    const result = await getRolePermissionsApi();
    const data = result?.data?.data;
    const rowsArray = Array.isArray(data) ? data : [];
    setRows(rowsArray);
    setOriginalRows(rowsArray);
  }, [getRolePermissionsApi]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleToggle = (id, roleName) => {
    setRows((prevRows) =>
      prevRows.map((row) => {
        if (row.id === id) {
          const hasRole = row.roles?.includes(roleName);
          return {
            ...row,
            roles: hasRole
              ? row.roles.filter((r) => r !== roleName)
              : [...(row.roles || []), roleName],
          };
        }
        return row;
      }),
    );
  };

  const handleSave = async () => {
    const payload = rows.map(({ createdAt, updatedAt, ...rest }) => rest);
    const result = await updateRolePermissionsApi({ rolePermissions: payload });
    if (result?.data?.status === "SUCCESS") {
      setOriginalRows(rows);
      toast.success(result.data.message || "Role permissions updated successfully");
    } else {
      toast.error(result?.data?.message || "Failed to update role permissions");
    }
  };

  const handleCancel = () => {
    setRows(originalRows);
  };

  return (
    <CommonPage>
      <Content>
        <PageTitle title="Permissions" classNames={["mb-5"]} />
        <div className="flex justify-end gap-2 mb-4">
          <SecondaryButton action={handleCancel} disabled={isUpdating}>
            <span className="flex items-center gap-1">Reset</span>
          </SecondaryButton>
          <PrimaryButton action={handleSave} disabled={isUpdating}>
            {isUpdating ? "Saving..." : "Save Changes"}
          </PrimaryButton>
        </div>
        <LoadableContent isLoading={isLoading} isError={isError}>
          <TableView rows={rows} onToggle={handleToggle} />
        </LoadableContent>
      </Content>
    </CommonPage>
  );
};
